<template>
  <div id="InformacionSentencia_div">
    <div id="encabezado-" class="form-inline justify-content-between">
      <h5 style="color: black">{{tituloDeInformacion}}</h5>
    </div>
    <hr class="mt-2" />
    <div>
      <!-- Fecha de dictado -->
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-4 ml-0 pl-1"  id="FechaDeDictado_div" >
            <h6 for="fechaDeDictado"  style="color: black">Fecha de dictado*</h6>
            <input type="date" id="fechaDeDictado" v-model="fechaDeDictado" class="form-control"/>
        </div> 
      <!-- Listado de delitos check -->
        <div v-if="sentencia.Delitos && sentencia.Delitos.length > 0" class="col-12 col-sm-12 col-md-8 col-lg-8 col-xlg-8 mb-4 ml-0 pl-1"  id="Delitos_div" >
            <h6 for="delitos"  style="color: black">Delitos*</h6>
            <label v-for="delito in sentencia.Delitos" v-bind:key="delito.Delito.DelitoId" style="text-transform: capitalize; font-size: 0.9rem;" class="mr-2 ml-2">
              <input type="checkbox" id="delitos" v-model="delito.Activo"  :value="delito.Delito.DelitoId" @change="verificarDelitosSeleccionados()"> {{ delito.Delito.Nombre.toLowerCase() }} 
            </label><br>  
        </div> 
      <!-- Tipos de resolución -->
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
            <h6 style="color: black">Resolución*</h6>
            <C003TiposResoluciones 
                style="padding:0; margin:0;" 
                v-on:valorParaElPadre="cambioTipoResolucion" 
                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                :idDelInput="'catalogoTiposResolucion'" 
                :parametros="{TipoResolucionId: null,ConInactivos: false}" 
                :valorDefinido="tipoResolucionId"></C003TiposResoluciones>
        </div> 
      <!-- Listado/Sublistado de Perspectiva de Género -->
        <div v-if="sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 ml-0 pl-1 mb-4 contenedor-color-gris"  id="PerspectivaDeGenero_div" >
            <h6 style="display:inline-block; color: black;">Perspectiva de género 
            <!--<i class="fas fa-chevron-left mr-4 ml-2" style="cursor:pointer" v-if="!mostrarPerspectivaDeGenero" @click="mostrarPerspectivaDeGenero = !mostrarPerspectivaDeGenero"></i>
            <i class="fas fa-chevron-down mr-4 ml-2" style="cursor:pointer" v-if="mostrarPerspectivaDeGenero" @click="mostrarPerspectivaDeGenero = !mostrarPerspectivaDeGenero"></i></h6>
            -->
            <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons" :key="togglePerspectivaRender">
              <label class="btn btn-secondary active" @click="mostrarPerspectivaDeGenero = !mostrarPerspectivaDeGenero">
                  <input type="radio" name="options" id="radioSi" autocomplete="off"> Si
              </label>
              <label class="btn btn-secondary" @click="mostrarPerspectivaDeGenero = !mostrarPerspectivaDeGenero">
                  <input type="radio" name="options" id="radioNo" autocomplete="off" checked> No
              </label>              
            </div>
            </h6>
            
            <div v-show="mostrarPerspectivaDeGenero">
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-2 px-0">
                <button type="button" class="btn btn-primary overwrapDeBotones"  @click="mensajeConfirmacionLimpiarListado()"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar listado</button>
              </div>
              <transition name="fade">
              <div v-if="!verificarListadoPerspectivaSeleccionados()" class="contenedor-puntero mt-1 mb-2 p-1">
                  <h6><i class="fas fa-info-circle"></i>&nbsp;Nota</h6>
                  <ul class="mb-0 pl-4">
                    <li>Asegurese de seleccionar al menos un elemento del sublistado marcado</li>
                  </ul>
              </div>
              </transition>
              <div class="row mx-0 border border-white p-2">
                <ul v-for="(clasificacion, indexClasificacion) in sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-4 ml-0 pl-1" v-bind:key="indexClasificacion + clasificacion.SentenciaClasificacionPerspectivaDeGeneroId">
                  <label v-show="((clasificacion.TipoClasificacionPerspectivaDeGeneroId_064DBPJ == 6 || clasificacion.TipoClasificacionPerspectivaDeGeneroId_064DBPJ == 7) && mostrarPerspectivaDeGenero ? sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero[2].SentenciaCaracteristicasPerspectivaDeGenero[0].Activo : mostrarPerspectivaDeGenero)" style="font-size: 0.9rem;color:black;">
                    <input type="checkbox" id="perpectivaDeGenero_1" v-model="clasificacion.Activo" @change="limpiarSublistado(clasificacion, indexClasificacion)"> {{clasificacion.TipoClasificacionPerspectivaDeGenero.Nombre}}
                  </label>
                  <li>
                    <ul v-show="mostrarPerspectivaDeGenero && clasificacion.Activo">
                      <li v-for="(caracteristica, index) in clasificacion.SentenciaCaracteristicasPerspectivaDeGenero" v-bind:key="index + caracteristica.SentenciaClasificacionPerspectivaDeGeneroId + caracteristica.CaracteristicaPerspectivaDeGeneroId_065DBPJ">
                        <label style="font-size: 0.8rem; color:black;" >
                          <input type="checkbox" id="perpectivaDeGenero_2" v-model="caracteristica.Activo"> {{caracteristica.CaracteristicaPerspectivaDeGenero.Nombre}}
                        </label>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
        </div> 
      <!-- Archivo DOCX o PDF de sentencia -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 mb-4 ml-0 pl-1">
          <h6 style="color:black;">Archivo de Sentencia*</h6>
          <!-- <div class="contenedor-puntero mt-1 mb-2 p-1">
            <h6 class="mb-0" style="display:inline-block;"><i class="fas fa-info-circle"></i>&nbsp;Nota: </h6>
            <span class="p-1" style="display:inline-block;">{{ archivoNoExiste ? mensajeArchivoNoExiste : mensajeTipoArchivo }}</span>
          </div> -->
          <div class="contenedor-puntero mt-1 mb-2 p-1" style="background-color: var(--verde-pj-100)">
                <h6><i class="fas fa-info-circle"></i>&nbsp;Nota</h6>
                <ul class="mb-0 pl-4">
                  <li v-if="archivoNoExiste" style='color:yellow;'>{{ mensajeArchivoNoExiste }}</li>
                  <li >{{mensajeTipoArchivo}}</li>
                </ul>
                <!-- <span style="text-align: justify; display:block;">Asegúrese de tener habilitadas las <b style='color:yellow;'>ventanas emergentes</b>, de lo contrario no podrá generar e imprimir su comprobante de cita. Una vez habilitadas las <b style='color:yellow;'>ventanas emergentes</b>, actualice esta página.</span> -->
            </div>
          <div v-if="sentenciaNombreDelArchivo && !cambiarArchivo" class="col-12 col-sm-12 col-md-12 col-lg-11 col-xlg-10 pl-0">
            <h6 style="display:inline-block; color:black;">Nombre del archivo encontrado: </h6> 
            <!-- sentencia.ArchivoOriginalRuta ? sentencia.ArchivoOriginalRuta : sentencia.ArchivoFinalRuta -->
            <div class="input-group mb-3">
              <input 
                type="text" 
                class="form-control" 
                style="display:inline-block; width:auto !important; height: auto !important;"
                v-model="sentenciaNombreDelArchivo"
                id="documento_encontrado_sentencia" 
                ref=""  
                :readonly="true">
              <div class="input-group-append">
                <button class="btn btn-secondary" type="button" @click="cambiarArchivoSentencia()">{{esAlta? "Adjuntar archivo" : "Cambiar archivo"}}</button>
              </div>
            </div>
          </div>
          <input 
              v-else-if="this.esWord"
              type="file" 
              id="documento_sentencia" 
              ref="" 
              :class="[!DOCUMENTO_SENTENCIA && mostrarErroresInput  ? 'form-control border border-danger': 'form-control']" 
              v-on:change="documentoSeleccionado($event)" 
              accept= ".DOC,.DOCX" 
          />
          <input 
              v-else
              type="file" 
              id="documento_sentencia" 
              ref="" 
              :class="[!DOCUMENTO_SENTENCIA && mostrarErroresInput  ? 'form-control border border-danger': 'form-control']" 
              v-on:change="documentoSeleccionado($event)" 
              accept=".DOC,.DOCX,.PDF" 
          />
        </div>
      <!-- Observaciones -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xlg-11 mb-4 ml-0 pl-1">
            <h6 style="color:black;">Observaciones</h6>
            <textarea  v-model="sentencia.Observaciones" type="text" rows="3" id="descripcion_contenido" :class="[!sentencia.Observaciones && mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="" />
            <hr />
        </div>
    </div>
    <!-- Botones guardar, visualizar/testar sentencia, cancelar -->
    <div class="d-flex row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-2 text-left">
            <button type="button" class="btn btn-danger overwrapDeBotones"  @click="cancelarAltaCambiosSentencia()"><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>
        </div> 
        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
        <div v-if="camposLlenos()" class="col-12 col-sm-12 col-md-8 col-lg-7 col-xlg-7 pb-1 text-right">
            <button v-if="((archivoEncontrado && !cambiarArchivo) || DOCUMENTO_SENTENCIA != null) && !this.esWord" type="button" v-bind:class="[ !esExtensionPDF ? 'btn-success': 'btn-primary','btn overwrapDeBotones mb-1']" @click="testarVisualizarSentencia()"><i class="fas fa-file fa-lg"></i>&nbsp;&nbsp;{{ !esExtensionPDF ? "Testar Sentencia" : "Previsualizar Sentencia"}}</button>
            <button v-if="((!esAlta && ((archivoEncontrado && !cambiarArchivo) || esExtensionPDF)) || (esAlta && esExtensionPDF)) && !this.esWord" type="button" class="btn btn-success overwrapDeBotones mb-1" @click="guardarSentencia()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar Sentencia</button>
            <button v-if="((archivoEncontrado && !cambiarArchivo) || DOCUMENTO_SENTENCIA != null) && this.esWord" type="button" v-bind:class="['btn-info','btn overwrapDeBotones mb-1']" @click="nuevoGuardarSentencia()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar versión pública</button>
        </div> 
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'

  Vue.use(VueMask);

  export default {
    data() {
      return {
        togglePerspectivaRender: 1,
        delitosCheck:{},
        delitosChecked:null,
        enumeraciones,
        fechaDeDictado:null,
        mostrarPerspectivaDeGenero: false,
        consecutivo: "",
        archivoEncontrado: false,
        archivoNoExiste: false,
        sentenciaNombreDelArchivo: null,
        tipoResolucionId:-1,  
        mostrarErroresInput: false,
        DOCUMENTO_SENTENCIA: null,
        documentoActualizado: true, //La última versión del documento está en servidor
        observaciones:null,
        esExtensionPDF:false,
        cambiarArchivo:false,
        contador:0,
        mensajeTipoArchivo: this.esWord ? 'Solo se permite ingresar archivos con extensión DOC o DOCX en su versión final (versión pública).' : 'Si desea testar el documento a través del sistema suba un archivo de extensión DOC o DOCX, de lo contrario, ingrese el archivo en su versión final en formato PDF.',
        mensajeArchivoNoExiste:'El archivo de ésta sentencia no existe, por favor agregue uno.'
      }
    },
    props: {
      esAlta: true,
      tituloDeInformacion: String,
      sentencia: Object,
      esWord: false
    },
    components: {
      C003TiposResoluciones: catalogos.SICSEN.C003TiposResoluciones
    },
    /**
     * Método encargado de cargar valores predetermidados en caso de haberlos.
     */
    beforeMount() { 
      if(this.sentencia.FechaDeDictado)
        this.fechaDeDictado = moment(this.sentencia.FechaDeDictado).format('YYYY-MM-DD');
      if(this.sentencia.TipoResolucion)
        this.tipoResolucionId = this.sentencia.TipoResolucion.TipoResolucionId;
      if(this.sentencia.Observaciones)
        this.observaciones = this.sentencia.Observaciones;

      if(this.sentencia.ExisteArchivoFinal && !this.sentencia.ExisteArchivoOrigen)
      {
        this.archivoEncontrado = true;
        this.sentenciaNombreDelArchivo = this.sentencia.ArchivoFinalRuta.replace(/^.*[\\\/]/, '');
        this.esExtensionPDF = true;
      }
      else if(this.sentencia.ExisteArchivoOrigen) 
      {
        this.archivoEncontrado = true;
        this.sentenciaNombreDelArchivo = this.sentencia.ArchivoOriginalRuta.replace(/^.*[\\\/]/, '');
        if(!this.sentencia.ArchivoOriginalRuta)
          this.esExtensionPDF = false;
      }

      if(!this.archivoEncontrado && ((this.sentencia.ArchivoFinalRuta && !this.sentencia.ExisteArchivoFinal) && ((this.sentencia.ArchivoOriginalRuta && !this.sentencia.ExisteArchivoOrigen) || !this.sentencia.ArchivoOriginalRuta)))
        this.archivoNoExiste = true;

      if(this.sentencia.Delitos)
      {
        this.verificarDelitosSeleccionados();
      }
    },
    methods: {
      /**
       * Método encargado de mostrar mensaje de confirmación para limpiar listado
       */
      mensajeConfirmacionLimpiarListado: function(){
        bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Si decide limpiar el listado, perderá los cambios realizados en perspectiva de género.<br />¿Desea continuar?",
            buttons: {
                cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                },
                confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Limpiar listado'
                }
            },
            callback: (respuestaLimpiar) => {
                if (respuestaLimpiar) {
                    this.limpiarListadoPerspectiva();
                }
            }
          });
      },
      /**
       * Método encargado de limpiar sublistado de checks de perspectiva de género
       */
      limpiarSublistado:function(clasificacionListado, indexClasificacion)
      {
        if(!clasificacionListado.Activo)
        {
          for (var j in clasificacionListado.SentenciaCaracteristicasPerspectivaDeGenero) {
            this.sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero[indexClasificacion].SentenciaCaracteristicasPerspectivaDeGenero[j].Activo = false;
          }
        }
      },
      /**
       * Método encargado de limpiar listado completo de perspectiva de género
       */
      limpiarListadoPerspectiva:function()
      {
        this.togglePerspectivaRender ++;
        for (var i in this.sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero) {
          this.sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero[i].Activo = false;
          for (var j in this.sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero[i].SentenciaCaracteristicasPerspectivaDeGenero) {
            this.sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero[i].SentenciaCaracteristicasPerspectivaDeGenero[j].Activo = false;
          }
        }
      },
      /**
       * Método encargado de verificar que el listado de perspectiva de género tenga elementos acivos del sublistado también
       */
      verificarListadoPerspectivaSeleccionados:function()
      {
        var carteristicaSeleccionada = true;
        this.sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero.forEach(clasificacionV => {                  
          if(clasificacionV.Activo)
          {
            var caracteristicasSeleccionado = clasificacionV.SentenciaCaracteristicasPerspectivaDeGenero.filter(caracteristicaV => {
              if(caracteristicaV.Activo)
                return caracteristicaV;
            });
            if(!(caracteristicasSeleccionado.length > 0))
              carteristicaSeleccionada = false;
          }
        });
        return carteristicaSeleccionada;
      },
      /** 
       * Metodo encargado de obtener el valor del item seleccionado en el catalogo 003TiposResolucion
       * @param {object} evento [evento emitido por el catalogo]
       */
      cambioTipoResolucion: function (evento) {
        this.tipoResolucionId = parseInt(evento.target.value);
      },
      /**
       * Función encargada para asignar valor de input correspondiente para archivo hacia la variable DOCUMENTO_SENTENCIA que 
       * posteriormente se enviara en la peticon para el alta de sentencia. 
       * @param {object} evento [evento emitido por el input tipo file correspondiente al archivo]
       */
      documentoSeleccionado:function(evento)
      {
        try {
          if(evento.target.files.length > 0) {
            console.log("nombre nuevo archivo::",evento.target.files[0]);
            const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
            if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO)) {
                this.DOCUMENTO_SENTENCIA = evento.target.files[0];
                this.documentoActualizado = false;
            }
            else {
                $("#documento_sentencia").val('');
                this.DOCUMENTO_SENTENCIA = null;
                if(this.esWord)
                  comun.mensajeDeAlerta('Para las sentencias sólo se permite subir archivos con las extensiones DOC y DOCX.<br>Seleccione otro archivo con una de las extensiones mencionadas.');
                else
                  comun.mensajeDeAlerta('Para las sentencias sólo se permite subir archivos con las extensiones PDF, DOC y DOCX.<br>Seleccione otro archivo con una de las extensiones mencionadas.');
            }
          }
          else {
            if(this.DOCUMENTO_SENTENCIA != null)
            {
              this.DOCUMENTO_SENTENCIA = null;
              this.documentoActualizado = false;
            }
              this.documentoActualizado = true;
          }
        }
        catch(error) {
            comun.mensajeDeAlerta(error);
        }
      },
      /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        if (this.sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero && !this.verificarListadoPerspectivaSeleccionados())
          return false;
        if (!this.fechaDeDictado) 
          return false;
        if ((this.sentencia.Delitos && !this.delitosChecked) || (this.delitosChecked  && this.delitosChecked.length <= 0))
          return false;
        if (!this.tipoResolucionId || this.tipoResolucionId <= 0) 
          return false;
        
        if (!this.DOCUMENTO_SENTENCIA && (this.archivoEncontrado && this.cambiarArchivo && !this.DOCUMENTO_SENTENCIA))
          return false;
        return true;
      },
      /** 
       * Metodo encargado de verificar que los delitos seleccionados
       */
      verificarDelitosSeleccionados:function()
      {
        this.delitosChecked = this.sentencia.Delitos.filter(delito => {                  
          if(delito.Activo)
            return delito;
        });
      },
      /**
       * Función encargada de verificar que un documento coincida con su extención, en base al nombre dado.  
       * @param {string} nombreArchivo [nombre correspondiente al archivo]
       */
      verificaQueSeaElDocumentoCorrecto: function(nombreArchivo) {
            const NOMBRE_CORTADO = nombreArchivo.split(".");
            let siEsUnDocumentoValido = false;
            const EXTENSION_ARCHIVO = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();

            if(!this.esWord && (EXTENSION_ARCHIVO === 'PDF' || EXTENSION_ARCHIVO === 'DOC' || EXTENSION_ARCHIVO === 'DOCX'))
                siEsUnDocumentoValido = true;
            
            if(this.esWord && (EXTENSION_ARCHIVO === 'DOC' || EXTENSION_ARCHIVO === 'DOCX'))
                siEsUnDocumentoValido = true;

            if(!this.esWord)
              this.esExtensionPDF = EXTENSION_ARCHIVO === 'PDF';

            return siEsUnDocumentoValido;
      },
      /** 
       * Metodo encargado de obtener el valor del item seleccionado en el catalogo 003TiposResolucion
       */
      cancelarAltaCambiosSentencia:function()
      {
        if(this.fechaDeDictado || 
           (this.delitosChecked  && this.delitosChecked.length <= 0) || 
           (this.tipoResolucionId && this.tipoResolucionId > 0) || 
           this.DOCUMENTO_SENTENCIA)
        {
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Si decide cancelar, perderá los cambios realizados.<br />¿Desea continuar?",
            buttons: {
                cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
                },
                confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y cancelar'
                }
            },
            callback: (respuestaCancelar) => {
                if (respuestaCancelar) {
                    this.$emit("cancelarAltaCambios");
                }
            }
          });
        }
        else 
          this.$emit("cancelarAltaCambios"); 
      },
      /**
       * Función encargada de verificar que el campo proporcionado tenga un valor valido.  
       * @param {string/int/other} campo 
       */
      campoRequeridoEsValido: function(campo) {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      /**
       * Función encargada de llamar la función API correspondiente para visualizar, testar o subir un documento de sentencia. 
       */
      testarVisualizarSentencia:function()
      {       
        if((!this.archivoEncontrado && this.DOCUMENTO_SENTENCIA) || (this.archivoEncontrado && this.cambiarArchivo && this.DOCUMENTO_SENTENCIA))
        {          
          this.$emit("subirArchivo", false, false);
          this.documentoActualizado = true;
        }
        else if(!this.esExtensionPDF){          
          this.$emit("testarSentencia");     
        }          
        else if(this.esExtensionPDF){          
          this.$emit("visualizarSentencia");
        }
      },
      /**
       * Función encargada de llamar a API para guardar una sentencia
       */
      guardarSentencia:function()
      {
        if(this.esExtensionPDF)
        {
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: this.esWord ? "Está por guardar un archivo en su versión final." : "Está por guardar un archivo en su versión final, si decide continuar no podrá testar, agregar marca de agua ni configurar la seguridad de dicho archivo. <br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y guardar'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
                if(!this.documentoActualizado)
                {
                  this.$emit("subirArchivo", true, false);
                  this.documentoActualizado = true;
                }
                else this.$emit("guardar");
              }
            }
          });
        }
        else this.$emit("guardar");
      },
      /**
       * Función encargada de llamar a API para guardar una sentencia
       */
      nuevoGuardarSentencia:function()
      {        
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Está por guardar un archivo en su versión final. <br />¿Desea continuar?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y guardar'
            }
          },
          callback: (respuestaContinuar) => {
            if (respuestaContinuar) {
              this.$emit("subirArchivo", false, false);
            }
          }
        });        
      },
      /**
       * Función encargada de habilitar los campos para cambiar archivo, y mostrar mensaje de confirmación
       */
      cambiarArchivoSentencia:function()
      {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: this.esAlta? "Está por adjuntar un archivo diferente. <br />¿Desea continuar?" : "Está por cambiar el archivo de la sentencia, si decide continuar el archivo actual será reemplazado con el nuevo al guardar. <br />¿Desea continuar?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar'
            }
          },
          callback: (respuestaContinuar) => {
            if (respuestaContinuar) {
              this.sentencia.PalabrasFrasesATestar = null;
              this.cambiarArchivo = true;
            }
          }
        });
      },
      /**
       * Función encargada de cambiar la ruta del archivo final (PDF)
       */
      cambioRutaArchivoFinal(ruta) 
      {
        this.$store.dispatch("A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal", ruta);
      },
      /**
       * Función encargada de cambiar la ruta del archivo original (DOC)
       */
      cambioRutaArchivoOrigen(ruta) 
      {
        this.$store.dispatch("A_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen", ruta);
      }
    },
    computed: {
      /**
       * Función encargada de obtener la ruta del archivo final (PDF)
       */
      obtenerRutaArchivoFinal() {
        return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoFinal;
      },
      /**
       * Función encargada de obtener la ruta del archivo original (DOC)
       */
      obtenerRutaArchivoOrigen() {
        return this.$store.getters.Get_SICSEN_Sentencias_InformacionSentencia_RutaArchivoOrigen;
      }
    }
  }
</script>
<style scoped>
  .contenedor-puntero {
    background: #212529;
    border-radius:2px;
    padding: 10px;
    border:1px solid white;
    margin-bottom: 1.5em;
  }
  .form-control:disabled, .form-control[readonly]
  {
    background-color: #3D3C40 !important;
    pointer-events: none;
    color: #aaa;
  }
  ul { 
    list-style: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .contenedor-color-gris {        
        background-color: #9ea1a3;
        /*box-shadow: 0px 6px 20px 8px #161616;*/
        padding: 25px
    }
</style>



// WEBPACK FOOTER //
// src/components/SICSEN/Administracion/InformacionSentencia.vue